module.exports = {
  normal: {
    nodata: 'No Data',
  },
  succ: {
    normal: '成功！',
  },
  login: {
    login: '使用GitHub登录',
    service_tip: '请勾选并同意服务条款',
  },
  index: {
    avatar: '用户头像',
    nav: {
      home: '主页',
      btnAriaLabel: '下拉按钮',
      account: '账号',
      settings: '设置',
      about: '关于',
      signOut: '注销',
      feedback: '反馈',
    },
    updateBtn: '同步',
    signOutConfirm: '是否退出?',
    finishUpdate: '更新完成',
    updateErr: '网络异常，请稍后再试',
    list: {
      allProject: '所有项目',
      overview: '总览',
      recommend: '推荐',
      explore: '探索',
      myCollections: '我的分类',
      githubCollections: 'GitHub默认分类',
      allStars: '所有项目',
      starWithoutCollect: '未分类',
      loadingText: '同步star数据中，请耐心等待...',
      starsDel: '最近删除',
    },
  },
  sortList: {
    byTime: '按时间',
    byName: '按名称(A-Z)',
    byNum: '按数量',
    bySartNum: '按Star数',
    byForkNum: '按Fork数量',
    byVisitTime: '按访问数量',
    byLikeNum: '点赞数',
  },
  starsPanel: {
    eidtCollectionAria: '编辑分类',
    search: '搜索',
    backAria: '返回',
    loadingText: '同步star数据中，请耐心等待...',
    copySucc: '已复制到剪贴板',
    copyManual: '已复制到剪贴板',
    editTip: '修改成功',
    serverErr: '服务器出错，请稍后再试哦',
    unStarTip: '已取消Star',
    delTrashStar: '删除成功',
    multiDelConfirm: '删除 {num} 个项目?',
    delConfirm: '删除「{name}」?',
    unstarCofirm: '取消 Star?',
    multiUnstarConfirm: '取消 Star {num} 个项目?',
    unstarConfirm: '取消 Star「{name}」?',
    multiStarConfirm: 'Star {num} 个项目?',
    starConfirm: 'Star「{name}」?',
    noSelect: '没有已选项目',
    toolbarUnstar: 'UnStar',
  },
  editPanel: {
    titleEdit: '修改分类',
    titleAdd: '添加分类',
    myCollections: '我的分类',
    recommend: '推荐分类名称',
    inputTip: '选择或者新建分类',
    inputPlaceholder: '请输入分类名称',
    inputwAria: '使输入框获取焦点',
    createNewTag: '新建{name}分类',
    addNewTag: '回车选择{name}分类',
    githubTagTip: 'GitHub默认分类',
  },
  noProjectTip: '无项目',
  accessToken: {
    title: 'Access token needed',
    tip_1: '该操作需要更多权限，请生成一个新的GitHub access token。Token将会保存在本地。',
    tip_2: '了解如何生成token和更多信息?',
    btn: '保存',
    inputTip: '请输入token',
    saveTip: 'Token已保存，你可以在设置面板编辑它🔧',
    errTip: 'Github access token 可能配置不对或者权限不够，请在设置面板中检查配置',
    errTip_404: '项目不存在或者Github访问权限不够',
  },
  settingPanel: {
    accessTokenInput: '请输入Token',
    tokenTip: '设GitHub Token🔑 来获取更多的选项和功能',
    tokenLink: '了解更多',
    tokenSetSucc: 'Token更新成功',
    panelSize: '界面大小',
    panelSizeBig: '大',
    panelSizeSmall: '小',
    theme: '界面样式',
    themeWhite: '白昼',
    themeDark: '黑夜',
    email: '邮件设置',
    emailBtn: '修改邮件地址',
    autoBackUp: '自动备份',
    backUpBtn: '立即备份',
    backTip: '备份将于每周日发送到您的邮箱',
    noEmailTip: '你还没有设置Email，立刻去设置？',
    sendEmailTip: '已发送备份到',
    sendEmailTip_2: '邮件可能会有延迟',
    language: '语言',
    langEn: '英文',
    langCn: '中文(简体)',
    hotKeys: '快捷键',
  },
  profile: {
    acAccountType: '账户等级',
    memberSince: '订阅时间',
    upgradeBtn: '升级为PRO',
    autoRenew: '自动更新订阅',
    subscribe: '管理订阅',
    subscribeCancel: '已取消自动订阅',
    paymentTip: '遇到支付问题请联系service@littlestarcloud.com',
  },
  emailPanel: {
    editBtn: '修改邮件',
    placeholder: '请输入邮件地址',
    verifyBtn: '验证邮件地址',
    cancelBtn: '取消修改',
    varifyUpdate: '已验证，立即更新信息',
    updateSucc: '更新成功',
    sendTip: '已发送邮件至',
    reSendTip: '没收到？重新发送',
    emailVarifyErr: '邮件格式错误',
    emailReqSuccTip: '已发送验证邮件到您的邮箱',
  },
  iconPanel: {
    title: '选择图标集',
    title2: '选择一个图标',
    noIconSet: '暂无图标集',
    noIcon: '暂无图标',
  },
  feedback: {
    placeholder1: '请输入您的邮件地址',
    placeholder2: '请输入您的反馈',
    btn: '提交',
    succ: '提交成功！感谢反馈！',
    back: '返回',
    emailErr: '邮件格式错误',
    conErr: '请填写反馈内容',
  },
  pay: {
    succText1: '支付成功！感谢您的支持！',
    succText2: 'Enjoy!',
    btn: '确定',
    checking: '检查支付中...',
    err: '支付遇到问题?请联系service@littlestarcloud.com',
    notDone: '支付未完成',
  },
  deail: {
    noReadme: '该项目无README',
    updatingText: '同步star数据中，请耐心等待',
  },
  c_toast: {
    btn: '确认',
    btnCancel: '取消',
  },
  about: {
    slogen: '一个用于管理GitHub Star项目的Chrome拓展',
  },
  toolbar: {
    categoresNameIvalid: '分类名称不能为空',
    editsucc: '修改成功',
    delTip: '确认删除分类么？',
    delSucc: '删除成功',
  },
  trend: {
    selectDatePlaceHolder: '请选择时间',
    selectLangPlaceHolder: '请选择语言',
    allLang: '所有语言',
    daily: '今日',
    weekly: '本周',
    monthly: '本月',
  },
  upgrade: {
    tip_1: '需要升级账户',
    tip_2: '你的支持将激励开发者和让LittleStar更好😉',
    btn: '升级账户',
  },
}
